export enum CONFIRMATION_TYPES {
  DELETE = 'DELETE',
  DELETE_NOTE = 'DELETE_NOTE',
  RESTORE = 'RESTORE',
  DISABLE = 'DISABLE',
  ENABLE = 'ENABLE',
  REMOVE = 'REMOVE',
  CUSTOM = 'CUSTOM',
}
